export const PAID_LEAVE = '/paid_leave/';
export const PAID_LEAVE_ID = id => `/paid_leave/${id}/`;
export const PAID_LEAVE_REFERENCE_PERIODS = '/paid_leave/reference_periods';
export const PAID_LEAVE_REFERENCE_PERIODS_BY_ID = userId =>
  `/paid_leave/reference_periods/${userId}`;
export const PAID_LEAVE_MANAGE = userId => `/paid_leave/${userId}/manage`;
export const CALCULATE_LAST_DAY = (startDate, totalDays) =>
  `/paid_leave/calculate_last_date/${startDate}/${totalDays}`;
